import Vue from 'vue'

export const moduleEditorDialogs = Vue.observable({
  items: [],
})

let dialogSequence = 0

function openDialog(type, options = {}) {
  dialogSequence += 1
  const key = `module-editor-${Date.now()}-${dialogSequence}`
  const item = {
    key,
    type,
    moduleId: options.moduleId ?? options.id ?? 'new',
    variant: options.variant ?? 0,
    initialType: options.initialType ?? options.moduleType ?? '',
    initialTable: options.initialTable ?? options.table ?? '',
    contextKey: key,
    title: options.title || (type === 'variant' ? 'Variante du module' : 'Édition du module'),
    width: options.width || 1900,
    persistent: Boolean(options.persistent),
    onSaved: typeof options.onSaved === 'function' ? options.onSaved : null,
    onClosed: typeof options.onClosed === 'function' ? options.onClosed : null,
  }
  moduleEditorDialogs.items.push(item)
  return item.key
}

export function openModuleEditor(options = {}) {
  return openDialog('module', options)
}

export function openModuleVariant(options = {}) {
  return openDialog('variant', options)
}

export function closeModuleEditor(key, result = null) {
  const index = moduleEditorDialogs.items.findIndex(item => item.key === key)
  if (index === -1) return
  const [item] = moduleEditorDialogs.items.splice(index, 1)
  if (item.onClosed) item.onClosed(result)
}

export function notifyModuleSaved(key, module) {
  const item = moduleEditorDialogs.items.find(dialog => dialog.key === key)
  if (item && item.onSaved) item.onSaved(module)
}

export function moduleEditorLocation(options = {}) {
  const query = {}
  if (options.type) query.type = options.type
  if (options.table) query.table = options.table
  return {
    name: 'engine-module-edit',
    params: { id: options.moduleId ?? options.id ?? 'new' },
    query,
  }
}

export function moduleVariantLocation(options = {}) {
  return {
    name: 'engine-module-variant-edit',
    params: {
      id: options.moduleId ?? options.id,
      variant: options.variant,
    },
  }
}
